module.exports = __webpack_public_path__ + "img/Kibe38.ef6eb085.jpg";